import { memo } from 'react';
// Local files
import Item from './Item/Item';
import BaseAnalysesList from 'components/Analyses/Common/BaseAnalysesList/BaseAnalysesList';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import useFifthAnalyses from 'hooks/useFifthAnalyses';
import { fifthAnalysesSelectors } from "features/fifthAnalyses";

const FifthAnalysesList = () => {
  const { getFifthAnalyses } = useFifthAnalyses();
  const { data, pagination } = useCustomSelector(fifthAnalysesSelectors.getFifthAnalysesData);
  const fetching = useCustomSelector(fifthAnalysesSelectors.fifthAnalysesIsFetching);

  return (
     <BaseAnalysesList
      fetchData={getFifthAnalyses}
      getData={data}
      isFetching={fetching}
      pagination={pagination}
      renderItem={(item) => <Item key={item.id} {...item} />}
    />
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <FifthAnalysesList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);